import React from 'react';
import { colors } from '../config';

const FormHint = ({ children, ...rest }) => (
  <div {...rest}>
    {children}

    <style jsx>{`
      div {
        color: ${colors.brown};
        font-size: 12px;
        line-height: 1.35;
        margin-top: 12px;
      }
    `}</style>
  </div>
);

export default FormHint;
